export default {
	userLogin: {
		uNamePlaceholder: '帳號、信箱或手機號碼',
		uNameRule: '請輸入帳號、信箱或手機號碼',
		pWPlaceholder: '請輸入密碼',
		passWordRule: '請輸入數字+英文字母（需包含大小寫），6-20位',
		passWordRule1: '請輸入數字+英文字母（需包含大小寫），8-20位',
		codeRule: '驗證碼為6位數',
		forgetPwd: '忘記密碼',
		confirm: '確定',
		setPwd: '數字+字母（包含大小寫），6-20位元',
		setPwd1: '數字+字母（包含大小寫），8-20位元',
		pwd: '輸入密碼',
		setAgainPwd: '再輸入密碼',
		confirmPwd: '密碼不一致',
		clickConfirm: '點擊完成驗證',
		confirmSuccess: '驗證成功',
		again: '重新獲取',
		againPass: '{time}秒後可重發',
		move: '請按住滑桿拖曳',
		loginInfo: ' 未註冊的手機號碼將自動註冊。勾選即代表您同意並接受',
		loginAccInfo: '同意並接受',
		service: '服務協定',
		and: '和',
		security: '隱私權政策',
		bindPhone: '綁定手機號碼',
		bindInfo: '您的企業微信暫未綁定手機號，請綁定後使用',
		bindInfo1: '您的微信暫未綁定手機號，請綁定後使用',
		bind: '綁定',
		otherWayLogin: '其他方式登入',
		copyright: '北京中科聞歌科技股份有限公司 ©2023 版權所有',
		icp: '京ICP備17022028號',
		webNum: '網信算備110108009321501230015號',
		webCode: '京公網安備 11010802034536號',
		phoneInfo: '請輸入正確的手機號碼',
		noPermission: '抱歉，您沒有登入權限',
		codeErr: '取得驗證碼失敗',
		codeContinue: '驗證失敗，請重試',
		slidConfirm: '請拖曳滑桿進行驗證',
		errMsg: '請求失敗',
		checkInfo: '請勾選「我已閱讀並同意服務協議、隱私權政策」',
		loginFail: '登入失敗，請重試',
		webErr: '網絡錯誤',
		codeInfo: '請輸入驗證碼',
		bindFail: '綁定失敗，請重試',
		ways: '其他登入方式',
		getCode: '取得驗證碼',
		oladPassInfo: '請輸入舊密碼',
		clear: '清除成功！',
	},
	loginWays: {
		phone: '短信登錄',
		qChat: '成功登入',
		password: '密碼登錄',
		wechat: '微信登錄',

	},
	setting: {
		unbind:'解綁',
		unbind1:'未綁定',
		unBindInfo:'解绑成功',
		setPwd: '修改密碼',
		baseInfo: '基礎資訊',
		userId: '帳號ID',
		phone: '手機號碼',
		user: '帳號',
		password: '密碼',
		email: '電子郵件',
		qchat: '企業微信',
		bind: '去綁定',
		time: '註冊時間',
		codeBind: '掃碼綁定',
		oldPwdPassword: '請輸入原密碼',
		newPwd: '請輸入新密碼',
		newAgainPwd: '請再輸入新密碼',
		forgetInfo: '為了確保您的帳號安全，請驗證身份。 認證成功後進行下一步操作。 ',
		findPwd: '找回密碼',
		resetPwd: '重設密碼',
		finsh: '完成',
		copySuccess: '複製成功',
		pwdSuccess: '密碼修改成功',
		bindSuccess: '綁定成功',
		accountSuccess: '帳號修改成功',
		eamilInput: '請輸入正確的信箱',
		emailSuccess: '郵箱修改成功',
		nameInput: '名稱不能為空',
		nameSuccess: '暱稱修改成功',
		confirmPwd: '確認密碼',
		adminSetPwd: '設定管理者密碼',
		adminPwd: '管理員密碼',
		singOut: '註銷賬戶',
		info1: '註銷賬戶將永久失效且不可恢復',
		info2: '以下信息將被清空且無法找回',
		info3: '· 您賬戶下的全部對話記錄',
		info4: '· 您創建的智能體信息',
		logout: '註銷成功',
	},
	user: {
		nickName: '暱稱',
		userManage: '使用者管理',
		userType: '使用者類型',
		balckLists: '黑名單',
		role: '角色',
		placeholdKeyW: '請輸入關鍵字',
		add: '新增',
		account: '帳號',
		userName: '使用者名稱',
		wgRole: '聞歌員工',
		otherRole: '外部客戶',
		time: '有效期限',
		loinTime: '註冊時間',
		loginTime: '最近登入',
		wordTest: '敏感字詞檢測',
		open: '開啟',
		close: '關閉',
		operation: '操作',
		edit: '編輯',
		delete: '刪除',
		logOut: '註銷',
		defriend: '封鎖',
		relieve: '解除',
		askLog: '問答記錄',
		resetPwd: '重設密碼',
		addUser: '新增使用者',
		editUser: '編輯使用者',
		accountPlaceHold: '請輸入帳號',
		accountInfo: "帳號不能是純數字，不能包含{'@'}",
		require: '必填項',
		input: '請輸入',
		email: '信箱',
		user: '用戶',
		abUser: '普通用戶',
		admin: '管理員',
		validTime: '有效時間',
		vip: 'vip权限',
		endTime: '截止時間',
		vipTime: 'VIP到期時間',
		remark: '備註',
		cancel: '取消',
		confirm: '確定',
		yes: '是',
		no: '否',
		resetSuccess: '重置成功',
		warning: '提示',
		confirmDelete: '確定刪除',
		deleteMsg: '刪除成功',
		leaveMsg: '離線成功',
		operateMsg: '操作成功',
		addMsg: '新增成功',
		editMsg: '編輯成功',
		edmitMsg: '提交失敗',
		third: '第三方帳號',
		setNick: '修改暱稱',
		setEmail: '修改信箱',
		setAccount: '修改帳號',
		pwd: '密碼',
		loginReset: '該裝置登入已失效',
		loginInfo: '你目前的帳號登入已失效,{second}s後自動進入新帳號',
		timeInfo: '{second}s自動進入',
		loginAgainInfo: '請重新登入',
		loginAgain: '重新登入',
		setPwd: '設定密碼',
		payFail: '支付失敗',
		paySuccess: '付款成功',
		serviceGift: '系統贈送',
		paySuccessTip1: '上次服務結餘',
		paySuccessTip2: ',扣除後的總餘額為',
		paySuccessTip3: ',請知悉',
		clearPwd: '清空管理員密碼',
		confirmClear: '確定清除管理員密碼？ ',
		free: '免費用戶',
		vipSelect: '付費訂閱',
		placeVip: '訂閱計劃',
		api: 'API服務',
		apiName: '獲取雅意API接口開發文檔（含本賬號專屬令牌）',
		apiBtn: '獲取',
		apiInfo: '已發送到郵箱',
		msgInfo: '請在基礎信息中填寫有效電子郵箱後獲取',
		timeInfo2: '獲取（{t}s）',
	},
	personal: {
		dataReview: '資料總覽',
		userId: '帳號ID',
		select: '請選擇',
		technology: '指令調用情況',
		useTotal: '呼叫統計',
		unit: '單位：次',
		serviceTotal: '服務呼叫統計',
		unitTimes: '共/次',
		custom: '最近消耗',
		customInfo: '費用說明',
		info: '提示',
		tokenInfo: '1 token 約等於 1.25 字元',
		equal: '約等於',
		customDetail: '消費明細',
		unitYuan: '單位：元',
		unitToken: '單位：tokens',
		difference: '目前剩餘tokens',
		arrears: '目前欠費tokens',
		total: '總計儲值',
		give: '贈送',
		yuan: '元',
		pay: '去儲值',
		payDetail: '儲值明細',
		paySituation: '儲值狀況',
		app: '應用程式',
		accountPay: '帳戶充值',
		moneyInfo: '1.請確保帳戶有足夠金額進行交易。',
		thirInfo: '2.儲值過程遇到交易問題，請前往對應的第三方付款平台確認。',
		checkInfo: '3.儲值完成後，可前往儲值管理-儲值明細查看交易記錄，帳戶總覽查看帳戶餘額。 ',
		canUse: '可用餘額',
		payWay: '支付平台',
		payTotal: '儲值金額',
		payConfiem: '確認儲值',
		payInfo: '確認付款即代表同意本平台',
		payFinish: '已完成付款',
		zfbPay: '支付寶支付',
		wechatPay: '微信支付',
		realPay: '實付',
		scanPay: '打開支付寶掃描二維碼完成付款',
		payService: '儲值協議',
		zfb: '支付寶',
		wechat: '微信',
		servicesInfo: '請勾選 「確認付款即代表同意本平台《儲值協議》」',
		payChoice: '請選擇儲值金額',
		paySuccess: '您已儲值成功，儲值金額等詳細資料請在',
		payCheck: '裡查看',
		userType: '使用者類型',
		payStatu: '支付狀態',
		payWays: '付款方式',
		placeHold: '請輸入使用者名稱/訂單編號',
		placeHold1: '請輸入訂單編號',
		export: '導出',
		number: '訂單編號',
		userName: '使用者名稱',
		money: '儲值金額（元）',
		giveMoney: '購買tokens',
		time: '儲值時間',
		systeamGiven: '系統贈送',
		success: '成功',
		fail: '失敗',
		categoryPlace: '全部分類',
		technologyPlace: '全部指令',
		useTime: '呼叫時間',
		category: '分類',
		techno: '指令',
		serName: '服務名稱',
		userTimes: '呼叫次數',
		toekn: '消費token',
		price: '單價',
		customInfos: '費用說明',
		customTotal: '消費金額（元）',
		totalTimes: '總呼叫次數',
		placehold2: '輸入手機號碼查詢單一使用者呼叫資料',
		noData: '暫無記錄',
		useUnit: '呼叫：次',
		useToken: '呼叫量：token',
		skillList: '指令列表',
		defineMoney: '自訂金額',
		readInfo: '請勾選」登陸即註冊，勾選即代表您同意並接受服務協議 與隱私權政策「',
		editSuccess: '修改成功',
		setSuccess: '密碼修改成功，需重新登入',
		selectAgent: '请选择智能体',
		addApplication: '新增应用',
		applyName: '应用名称',
		smartAgent: '智能體',
		appNodata: '暫無智慧體',
		releaseDate: '發佈時間',
		pubSuccess: '已複製發佈連結',
		link: '連結',
		isEnabled: '是否啟用',
		conversationRecord: '對話記錄',
		chatRecord: '聊天記錄',
		rename: '重新命名',
		disableSmartAgentApp: '停用智慧體應用',
		disableDescription: '停用後，該應用對應連結將失效，其他用戶將無法通過連結繼續與該智慧體對話。',
		selectSmartAgentToPublish: '請選擇要發佈的智慧體',
		public: '公開',
		shareToMe: '分享給我',
		my: '我的',
		publish: '發佈',
		enabled: '已啟用',
		disabled: '已停用',
		enterName: '請輸入名稱',
		application: '應用',
		conversation: '對話',
		work: '作品',
		enterApplicationName: '請輸入應用名稱',
		selectVisitor: '請選擇訪問者',
		visitor: '訪問者',
		ipAddress: 'IP位址',
		visitorConversationCreateTime: '訪問對話建立時間',
		view: '查看',
		viewConversationRecord: '查看對話記錄',
		workCreateTime: '作品建立時間',
		generating: '生成中',
		generationFailed: '生成失敗',
		generationCompleted: '生成完成',
		status: '狀態',
		type: '生成插件',
		longText: '詳情',
	},
	router: {
		personalCenter: '個人中心',
		accountOverview: '帳戶總覽',
		personalPublic: '發佈管理',
		rechargeManagement: '充值管理',
		accountRecharge: '帳戶儲值',
		rechargeDetails: '充值明細',
		consumptionDetails: '消費明細',
		callStatistics: '呼叫統計',
		accountSettings: '帳戶設定',
		backendManagement: '後台管理',
		dataStatistics: '資料統計',
		overview: '總覽',
		userManagement: '使用者管理',
		applicationManagement: '申請管理',
		YAYIChat: 'YAYIChat',
		YAYILit: 'YAYILit',
		skillApplicationManagement: '指令應用程式管理',
		skillCategoryManagement: '指令分類管理',
		likeAndDislikeManagement: '讚踩管理',
		QAndARecords: '問答記錄',
		YAYIFile: 'YAYIFile',
		knowledgeBaseManagement: '知識庫管理',
		login: '登入',
		trialApplication: '試用申請',
		serviceAgreement: '服務協議',
		privacyPolicy: '隱私權政策',
		advancedSetting: '高級設置',
	},
	manage: {
		totalUser: '使用者總數',
		individual: '個人',
		enterprise: '企業',
		totalCall: '總呼叫次數',
		errorCall: '呼叫失敗次數',
		dataOverview: '資料總覽',
		pleaseSelect: '請選擇',
		all: '全部',
		rechargeStatus: '儲值情況',
		rechargeDetails: '充值明細',
		currencyUnit: '單位：元',
		skillCallStatus: '指令呼叫狀況',
		callStatistics: '呼叫統計',
		timesUnit: '單位：次',
		serviceCallStatistics: '服務呼叫統計',
		TotalAndCount: '共/次',
		userTypes: '使用者類型',
		paymentStatus: '付款狀態',
		paymentStatusTitle: '付款狀態',
		PaymentMethods: '付款方式',
		userAndOrderPlaceholder: '請輸入使用者名稱/訂單編號',
		orderPlaceholder: '請輸入訂單編號',
		export: '導出',
		orderNumber: '訂單編號',
		userName: '使用者名稱',
		rechargeAmount: '儲值金額（元）',
		bonusAmount: '購買tokens',
		rechargeTime: '儲值時間',
		paymentMethod: '付款方式',
		systemGift: '系統贈送',
		wechat: '微信',
		aliPay: '支付寶',
		success: '成功',
		failure: '失敗',
		callDataPlaceholder: '輸入手機號碼查詢單一使用者呼叫資料',
		noRecord: '暫無記錄',
		skillList: '指令列表',
		amountUnit: '呼叫量：token',
		numberUnit: '單位：次',
		userManagement: '使用者管理',
		blacklist: '黑名單',
		role: '角色',
		keywordPlaceholder: '請輸入關鍵字',
		add: '新增',
		newUser: '新增',
		phoneNumber: '手機號碼',
		staff: '聞歌員工',
		customer: '外部客戶',
		validDuration: '有效期限',
		registrationTime: '註冊時間',
		lastLogin: '最近登陸',
		sensitiveWordDetection: '敏感字偵測',
		enable: '開啟',
		disable: '關閉',
		operation: '操作',
		edit: '編輯',
		delete: '刪除',
		block: '拉黑',
		remove: '解除',
		QAndARecords: '問答記錄',
		addUser: '新增使用者',
		editUser: '編輯使用者',
		phonePlaceholder: '請輸入手機號碼',
		required: '必填項',
		placeholder: '請輸入',
		email: '信箱',
		user: '使用者',
		generalUser: '普通使用者',
		admin: '管理員',
		validDuration2: '有效時間',
		remarks: '備註',
		cancel: '取消',
		confirm: '確定',
		yes: '是',
		no: '否',
		blocked: '是',
		notBlocked: '否',
		phoneValidPlaceholder: '請輸入正確的手機號碼',
		emailValidPlaceholder: '請輸入正確的信箱',
		confirmTitle: '提示',
		sureDelete: '確定刪除',
		deletionSuccessful: '刪除成功',
		offlineSuccessful: '離線成功',
		operationSuccessful: '操作成功',
		additionSuccessful: '新增成功',
		editSuccessful: '編輯成功',
		createSuccessful: '新建成功',
		submissionFailed: '提交失敗',
		applicationManagement: '申請管理',
		industry: '所屬行業',
		industryTitle: '所屬產業',
		approvalStatus: '審核狀態',
		name: '姓名',
		companyName: '公司名稱',
		businessScenario: '業務場景',
		source: '來源',
		serviceObject: '服務物件',
		internal: '內部',
		external: '外部',
		applicationTime: '申請時間',
		status: '狀態',
		toBeApproved: '待審核',
		approved: '已通過',
		rejected: '已拒絕',
		評論: '審核',
		auditResult: '審核',
		approvalResult: '審批結果',
		invitationCode: '邀請碼',
		emailSent: '已通過且發送郵件',
		emailSent2: '透過且發送郵件',
		reason: '理由',
		sending: '發送中',
		submit: '提交',
		rejectReason: '拒絕原因',
		optional: '非必填',
		reject: '拒絕',
		sendSuccessful: '發送成功',
		invalidEmail: '郵箱無效',
		skillApplicationManagement: '指令應用程式管理',
		roleQuery: '角色查詢',
		category: '所屬分類',
		categoryTitle: '所屬分類',
		skillID: '指令ID',
		skillName: '指令名稱',
		recommendedSkill: '推薦指令',
		example: '範例',
		permission1: '權限',
		permission: '權限',
		public: '公開',
		private: '私有',
		creationTime: '建立時間',
		creator: '創建人',
		enable2: '上線',
		disable2: '下線',
		disableTheSkill: '確定下線？ ',
		newSkill: '新增',
		addSkill: '新增指令',
		editSkill: '編輯指令',
		pleaseEnterTheSkillName: '請輸入指令名稱',
		beta: '是否標記beta',
		pleaseSelectTheCategory: '請選取所屬分類',
		moreThanOneOption: '多選項',
		skillIntroduction: '指令簡介',
		pleaseEnterTheTemplateContent: '請輸入範本內容',
		backgroundRole: '背景角色',
		recommendedQuestions: '推薦問題',
		promptEmptyPlaceholder: '請輸入Prompt',
		variable: '變數',
		variablePlaceholder: '請輸入變數範例值',
		noData: '暫無資料',
		creativity: '創造力',
		save: '儲存',
		saveAndPublish: '儲存並發布',
		debug: '調試',
		promptPreview: 'Prompt 預覽',
		promptPreviewTip: '左側輸入Prompt即可即時預覽',
		run: '運行',
		result: '結果',
		時間: '耗時',
		takeToken: '花費Token',
		generateResult: '結果生成...',
		variableName: '變數名稱',
		type: '類型',
		string: '字串',
		publishSuccessful: '發布成功',
		takenDownSuccessful: '下架成功',
		copySuccessful: '複製成功',
		deleteSkill: '您確定要刪除該指令嗎？ ',
		deleteSkillAlert: '刪除後指令將無法恢復，請謹慎操作',
		skillCategoryManagement: '指令分類管理',
		categoryID: '類目ID',
		categoryName: '類別目名稱',
		description: '描述',
		addCategory: '新增分類',
		editCategory: '編輯分類',
		pleaseEnterTheCategoryName: '請輸入類別目名稱',
		thumbsUpAndDownQA: '智能問答讚踩',
		thumbsUpAndDownType: '讚踩類型',
		thumbsUpAndDownTypeTitle: '讚踩型',
		keywordOrPhone: '請輸入關鍵字/手機號碼',
		thumbsUp: '讚',
		thumbsDown: '踩',
		category2: '分類',
		feedback: '讚踩回饋',
		feedbackTitle: '讚踩回饋',
		QAndA: '問題及答案',
		applicationAndParameters: '應用程式及參數',
		IPAddress: 'IP位址',
		userAgent: 'userAgent',
		userPhoneNumber: '使用者手機',
		feedbackUser: '回饋使用者',
		toBeReviewed: '未審核',
		approved2: '贊同',
		disapproved: '不贊同',
		application: '應用',
		applicationParameters: '應用參數',
		reasonsForDisagreement: '不贊同的原因',
		thumbsUpDownManagement: '讚踩管理',
		likeAndDislikeManagement: '讚踩管理',
		feedbackTime: '回饋時間',
		approvalResult2: '審核結果',
		IntelligentQAndALog: '智慧問答記錄',
		category3: '應用行業',
		category3Title: '應用產業',
		sensitive: '是否敏感',
		sensitiveTitle: '是否敏感',
		YaYiInputParameter: 'YaYi入參',
		prompt: '提示詞',
		calledPlugin: '呼叫插件',
		pluginOutput: '插件輸出',
		notSensitive: '不敏感',
		sensitive2: '敏感',
		time2: '時間',
		category4: '應用類型',
		target: '目標',
		knowledgeBaseManagement: '知識庫管理',
		keywordAndUser: '請輸入知識庫關鍵字/使用者手機號碼',
		knowledgeBaseID: '知識庫ID',
		knowledgeBaseName: '知識庫名稱',
		knowledgeBaseNameTitle: '知識庫名稱',
		publiclyAccessible: '全部公開',
		internallyAccessible: '對內公開',
		numberOfFiles: '檔案數',
		wordCount: '字數統計',
		expand: '擴容',
		addKnowledgeBase: '新增知識庫',
		editKnowledgeBase: '編輯知識庫',
		pleaseEnterTheKnowledgeBaseName: '請輸入知識庫名稱',
		icon: '圖示',
		description2: '簡介',
		brieflyDescribe: '請簡單介紹下這個知識庫',
		deleteKnowledgeBase: '您確定要刪除該知識庫嗎？ ',
		deleteKnowledgeBaseAlert: '刪除後知識庫將無法恢復，請謹慎操作。 ',
		comingSoon: '敬請期待',
		knowledgeBaseQAndA: '知識庫問答讚踩',
		likeAndDislikeType: '讚踩類型',
		likeAndDislikeTypeTitle: '讚踩型',
		knowledgeBaseQAndALogs: '知識庫問答記錄',
		searchResult: '檢索結果',
		searchParameter: '檢索參數',
		knowledgeBase: '知識庫',
		userPrivate: '私有',
		permissionType: '類型',
		newRepo: '新增',
		userAdd: '新增',
		account: '帳號',
		tableuserName: '使用者名稱',
		userType: '使用者類型',
		tabletime: '有效期限',
		normalUser: '正常用戶',
		deletedUser: '已刪除使用者',
		logoutUser: '登出使用者',
		blockUser: '駭用戶',
		haveDeleted: '已刪除',
		haveLogOut: '已登出',
		emaillInfo: '請輸入正確的信箱格式',
		aiDraw: 'AI繪畫',
		experience: '體驗模式',
		longFile: '長文檔',
		graphicsSelection: '圖形選擇',
		backgroundColor: '背景顏色',
	},
	log: {
		manageLog: '安全審計',
	},
};
